const PolygonForModal2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="376"
      height="343"
      viewBox="0 0 376 343"
      fill="none"
    >
      <g filter="url(#filter0_f_99_562)">
        <circle
          cx="47"
          cy="329"
          r="129"
          fill="url(#paint0_linear_99_562)"
          fill-opacity="0.7"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_99_562"
          x="-282"
          y="0"
          width="658"
          height="658"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="100"
            result="effect1_foregroundBlur_99_562"
          />
        </filter>
        <linearGradient
          id="paint0_linear_99_562"
          x1="47"
          y1="200"
          x2="47"
          y2="458"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2D061B" />
          <stop offset="1" stop-color="#B9317A" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PolygonForModal2;
